import { render, staticRenderFns } from "./TheFacilitiesKeyDetails.vue?vue&type=template&id=3c96fc0d&"
import script from "./TheFacilitiesKeyDetails.vue?vue&type=script&lang=js&"
export * from "./TheFacilitiesKeyDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports